import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Layout.css';

const Layout = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <aside className="sidebar">
        <div className="logo">
           <img src="/eduLogo.png" alt="Eduthrift Admin Logo" />
        </div>
        <nav>
          <ul>
            <li><NavLink to="/dashboard" className={({ isActive }) => isActive ? 'active' : ''}>Dashboard</NavLink></li>
            <li><NavLink to="/users" className={({ isActive }) => isActive ? 'active' : ''}>Users</NavLink></li>
            <li><NavLink to="/sellers" className={({ isActive }) => isActive ? 'active' : ''}>Verify Sellers</NavLink></li>
            <li><NavLink to="/school-shops" className={({ isActive }) => isActive ? 'active' : ''}>School Shops</NavLink></li>
            <li><NavLink to="/schools" className={({ isActive }) => isActive ? 'active' : ''}>Listed Schools</NavLink></li>
            <li><NavLink to="/broadcast" className={({ isActive }) => isActive ? 'active' : ''}>Broadcast</NavLink></li>
            <li><NavLink to="/reports" className={({ isActive }) => isActive ? 'active' : ''}>Reports</NavLink></li>
            <li><NavLink to="/payments" className={({ isActive }) => isActive ? 'active' : ''}>Payments</NavLink></li>
            <li><NavLink to="/shipments" className={({ isActive }) => isActive ? 'active' : ''}>Shipments</NavLink></li>
            <li><NavLink to="/wallets" className={({ isActive }) => isActive ? 'active' : ''}>TradeSafe Wallets</NavLink></li>
            <li><NavLink to="/disputes" className={({ isActive }) => isActive ? 'active' : ''}>Disputes</NavLink></li>
            <li><NavLink to="/callbacks" className={({ isActive }) => isActive ? 'active' : ''}>Callbacks</NavLink></li>
            <li><NavLink to="/server" className={({ isActive }) => isActive ? 'active' : ''}>Server</NavLink></li>
          </ul>
        </nav>

        
        <button onClick={handleLogout} className="logout-btn">Logout</button>
      </aside>
      <main className="content">
        {children}
      </main>
    </div>
  );
};

export default Layout;
